function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.225 7.7C8.825 0.1 21.225 0.1 28.825 7.7C29.125 7.9 29.125 8.3 28.825 8.6C28.725 8.7 28.625 8.8 28.425 8.8C28.225 8.8 28.125 8.7 28.025 8.6C20.925 1.4 9.325 1.4 2.125 8.6C1.825 8.8 1.425 8.8 1.225 8.6C0.925 8.3 0.925 7.9 1.225 7.7ZM5.42502 11.9C8.02502 9.29999 11.425 7.89999 15.025 7.89999C18.625 7.89999 22.025 9.29999 24.525 11.9C24.725 12.2 24.725 12.6 24.525 12.8C24.425 12.9 24.325 13 24.125 13C23.925 13 23.825 12.9 23.725 12.8C21.425 10.5 18.325 9.19999 15.025 9.19999C11.725 9.19999 8.62502 10.5 6.32502 12.8C6.02502 13 5.62502 13 5.42502 12.8C5.22502 12.5 5.22502 12.1 5.42502 11.9ZM9.62498 16.1C9.42498 16.3 9.42498 16.7 9.62498 17C9.82498 17.2 10.225 17.2 10.525 17C13.125 14.5 17.225 14.5 19.725 17C19.825 17.1 19.925 17.2 20.125 17.2C20.225 17.2 20.425 17.1 20.525 17C20.725 16.8 20.725 16.4 20.525 16.1C17.425 13.1 12.625 13.1 9.62498 16.1ZM11.525 24.8C11.525 22.9 13.025 21.3 15.025 21.3C16.925 21.3 18.525 22.8 18.525 24.8C18.525 26.7 16.925 28.3 15.025 28.3C13.125 28.3 11.525 26.8 11.525 24.8ZM12.725 24.8C12.725 26.1 13.725 27.1 15.025 27.1C16.225 27.1 17.325 26.1 17.325 24.8C17.325 23.5 16.325 22.5 15.025 22.5C13.725 22.5 12.725 23.5 12.725 24.8Z",
  fill: "#1C33C8"
});

var SvgWlan = function SvgWlan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWlan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wlan.6fca8bc1.svg";
export { ForwardRef as ReactComponent };